// pages/tasks/hooks/useTaskData.ts
import { useState, useEffect, useCallback } from "react";
import { useClientStore, useUserStore } from "@/store";

export const useTaskData = () => {
  const { clients, fetchClients, loading: clientsLoading } = useClientStore();
  const { users, fetchUsers, loading: usersLoading } = useUserStore();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchUsers();
    fetchClients({ page: 1, limit: 100, search: "", isActive: true });
  }, [fetchUsers, fetchClients]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchClients({ page: 1, limit: 100, search: searchTerm, isActive: true });
    }, 500);
    return () => clearTimeout(handler);
  }, [searchTerm, fetchClients]);

  return {
    clients,
    clientsLoading,
    users,
    usersLoading,
    searchTerm,
    setSearchTerm,
  };
};